// packages
import defaults from 'underscore/modules/defaults.js';

// local
import http from '$shared/http.js';
import template from './post-item.mustache';

export default class TableOfContents {
  constructor(options) {
    /** @type {HTMLElement} */
    this.el = options.el;
    this.config = this.el.dataset;

    this.fetchData();
  }

  setDefaults(options) {
    return defaults(options, {
      maxPosts: 3,
      loaded: false,
    });
  }

  async fetchData() {
    if (this.el.getAttribute('data-loaded') === 'true') {
      return;
    } else {
      this.el.setAttribute('data-loaded', 'true');
    }

    const data = await http.get(this.config.path).json();

    this.data = data;
    this.data.posts = this.data.posts.slice(0, this.config.maxPosts);
    this.renderTemplate();
  }

  hideChrome() {
    this.el.closest('.sidebar-toc').style.display = 'none';
  }

  renderTemplate() {
    if (
      this.data.posts.length === 0 ||
      (this.data.posts.length === 1 &&
        this.data.posts[0].id === this.config.postId)
    ) {
      this.hideChrome();
      return;
    }

    const listItems = [];

    this.data.posts.forEach((post) => {
      post.is_current = post.id === +this.config.postId;

      listItems.push(template.render(post));
    });

    this.el.innerHTML = listItems.join('');
  }

  render() {}
}
